import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _RATE_STATUS_ICON_MAP;

import { CheckCircleOutlined, CloseCircleOutlined, FormOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { RateStatusType } from 'core/client';
import { Colors } from 'core/interfaces/variables.types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
var RATE_STATUS_ICON_MAP = (_RATE_STATUS_ICON_MAP = {}, _defineProperty(_RATE_STATUS_ICON_MAP, RateStatusType.Draft, /*#__PURE__*/_jsx(FormOutlined, {
  style: {
    color: Colors.blue[6]
  }
})), _defineProperty(_RATE_STATUS_ICON_MAP, RateStatusType.Active, /*#__PURE__*/_jsx(CheckCircleOutlined, {
  style: {
    color: Colors.green[6]
  }
})), _defineProperty(_RATE_STATUS_ICON_MAP, RateStatusType.Decommissioned, /*#__PURE__*/_jsx(CloseCircleOutlined, {
  style: {
    color: Colors.red[5]
  }
})), _RATE_STATUS_ICON_MAP);
export var RateStatusIcon = function RateStatusIcon(_ref) {
  var status = _ref.status,
      withTooltip = _ref.withTooltip;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return useMemo(function () {
    return /*#__PURE__*/_jsx(Tooltip, {
      open: withTooltip ? undefined : false,
      title: t("form.rate.status.values.".concat(status)),
      children: RATE_STATUS_ICON_MAP[status]
    });
  }, [status]);
};